import React from "react";
import Stack from "@mui/material/Stack";

import i18n from "../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import ET3PageDiv from "../../../../core/et3-page-div";
import Et3PageTitle from "../../../../core/et3-page-title/index";
import getKhattabatMatchingStore from "../../../../stores/khattabat-stores/matching-stores";
import getCoreHistoryStore from "../../../../stores/core/core-history-store";
import Form from "./form";
import FormActions from "./form/FormActions";
import PaidUserSelect from "./form/PaidUserSelect";
import CreateOneOOneM from "./create-101m";
import MatchesFoundCount from "./MatchesFoundCount";

const KhattabatSearchingAnd101M = withLiteObserverAndTheme((props) => {
  const { unitX } = props.theme;

  React.useEffect(() => {
    getCoreHistoryStore().setPageName(
      "KHATTABAT_MATCHING_SEARCH_AND_1O1M",
      "KHATTABAT_MATCHING_SEARCH_AND_1O1M"
    );
    getKhattabatMatchingStore().getPaidUsersInformation();
  });

  React.useEffect(() => {
    return () => getKhattabatMatchingStore().closeMultiSelect();
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{ position: "relative" }}
    >
      <Et3PageTitle
        title={i18n.get("KHATTABAT_MATCHING_SEARCH_AND_1O1M")}
        subTitle={""}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <Stack
        spacing={2}
        sx={{ alignSelf: "stretch", pb: 2, pr: `${40 * unitX}px` }}
      >
        <PaidUserSelect />
        <Form />
        <FormActions />
        <MatchesFoundCount />
        <CreateOneOOneM />
      </Stack>
    </ET3PageDiv>
  );
});
export default KhattabatSearchingAnd101M;
